import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useSwipeBack } from "@/hooks/useSwipeBack";
import { PrivacyPolicyContent } from "@/components/PrivacyPolicyContent";
import { Analytics } from "@/lib/analytics";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useSwipeBack();
  
  useEffect(() => {
    Analytics.privacyPolicyViewed();
  }, []);

  return (
    <div 
      className="bg-gradient-bg p-4"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        paddingTop: 'calc(env(safe-area-inset-top, 0px) + 16px)',
        paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 32px)',
      }}
    >
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="flex items-center gap-4 mb-6">
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate(-1)}
            className="border-border/50"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            {t('legal.back')}
          </Button>
          <h1 className="text-2xl font-bold">{t('legal.privacy.screenTitle')}</h1>
        </div>

        <Card className="bg-gradient-card border-border/50">
          <CardHeader>
            <CardTitle className="text-2xl">{t('legal.privacy.documentTitle')}</CardTitle>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none">
            <PrivacyPolicyContent />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
